import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/api";
import { Logo } from "@/components/Logo";

function FullLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background">
      <div className="animate-float-slow"><Logo /></div>
      <div className="h-1 w-40 rounded-full bg-slate-200 overflow-hidden">
        <div className="h-full w-1/2 bg-cyan animate-[shimmer_1.2s_infinite]" />
      </div>
    </div>
  );
}

export default function ProtectedRoute({ allow, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
